<template>
  <div id="biz-week-plan-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1 />
      <span>周预装机跟进管理</span>
    </div>
    <dv-scroll-board id="biz-week-table" :config="config" />
  </div>
</template>

<script>
export default {
  name: 'BizWeekPlanTable',
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableDataList: [],
      config: {}
    }
  },
  watch: {
    chartData: {
      handler(v) {
        var arr = []
        if (!v || v.length === 0) {
          arr.push([
            '<span style="color: #999;" colspan="7">暂无数据</span>',
            '-', '-', '-', '-', '-', '-'
          ])
        } else {
          for (var i = 0; i < v.length; i++) {
            arr.push([
              v[i].province || '',
              v[i].city || '',
              v[i].hospitalName || '',
              v[i].hospitalLevel || '',
              v[i].planInstallDate || '',
              v[i].contact || '',
              String(v[i].estimatedMonthlyVolume || 0)
            ])
          }
        }
        this.tableDataList = arr
        this.setConfig()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setConfig()
    })
  },
  methods: {
    setConfig() {
      const isMobile = window.innerWidth <= 768
      this.config = {
        header: ['省份', '地级市', '医院名称', '等级', '预计装机', '联系方式', '月检测量'],
        data: this.tableDataList,
        columnWidth: isMobile ? [45, 50, 80, 40, 75, 100, 55] : [55, 65, 120, 50, 85, 130, 70],
        headerBGC: 'rgba(36, 203, 241, .1)',
        oddRowBGC: 'rgba(125, 155, 243, .2)',
        evenRowBGC: 'rgba(125, 155, 243, .1)',
        rowNum: isMobile ? 5 : 6,
        align: ['center', 'center', 'center', 'center', 'center', 'center', 'center'],
        headerHeight: 35,
        index: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#biz-week-plan-box {
  background: rgba(10, 57, 130, 0.6);
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .chart-title {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: bolder;
    padding: 8px 15px;
    background: rgba(10, 57, 130, 0.6);
    position: relative;
    flex-shrink: 0;

    .charts-icon {
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .dv-decoration-1 {
      width: 60px;
      height: 20px;
      margin-left: 40px;
    }

    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }

  #biz-week-table {
    padding: 0 5px 5px 5px;
    flex: 1;
    min-height: 0;
  }
}
</style>

<!-- 全局样式穿透 dv-scroll-board 内部元素 -->
<style>
#biz-week-plan-box .dv-scroll-board {
  width: 100% !important;
}
#biz-week-plan-box .dv-scroll-board .header {
  width: 100% !important;
}
#biz-week-plan-box .dv-scroll-board .rows {
  width: 100% !important;
}
#biz-week-plan-box .dv-scroll-board .header .header-item {
  padding: 0 4px !important;
  font-size: 12px;
  font-weight: bold;
}
#biz-week-plan-box .dv-scroll-board .rows .ceil {
  padding: 0 4px !important;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
